<template>
	<v-btn class="btn-urgent" :class="{'--active': isUrgent}" icon small
		   :disabled="disabled"
		   :title="title"
		   @click.stop.prevent="onClick">
		<loader v-if="isSaving" small/>
		<v-icon v-else :color="isUrgent ? 'error' : 'grey lighten-1'" small>
			mdi-fire
		</v-icon>
	</v-btn>
</template>

<script>
import base from "@/mixins/base";

/** Кнопка "срочная задача": одна срочная задача на пользователя в группе */
export default {
	name: "btn-urgent",
	mixins: [base],
	props: {
		item: {
			type: Object,
		},
		disabled: {
			type: Boolean,
			default: false
		},
	},
	data: () => ({
		isSaving: false,
	}),
	computed: {
		/** Задача отмечена срочной хотя бы в одной группе (task.urgentInGroupIds) */
		isUrgent() {
			return !!this.item.urgentInGroupIds?.length;
		},
		title() {
			return this.isUrgent ? "Самая важная задача!" : "Горит!";
		},
	},
	methods: {
		/** Переключает признак срочности задачи для исполнителя (или пользователя по правилам Tasks.create()) */
		async onClick() {
			if (this.disabled || this.isSaving) return;
			this.isSaving = true;
			try {
				await this.do("context/setUrgentTask", {
					taskId: this.item.id,
					urgent: !this.isUrgent,
					userId: this.item.userId || undefined,
					contextId: this.context.item?.id,
				});
			} finally {
				this.isSaving = false;
			}
		},
	},
}
</script>

<style lang="scss">
.btn-urgent {
	position: relative;
	z-index: 1;
	flex-shrink: 0;

	&.v-btn {
		width: 24px;
		height: 24px;
		max-width: 24px;
		max-height: 24px;
	}
}
</style>
